import { render, staticRenderFns } from "./AddCategoryModal.vue?vue&type=template&id=1fc26ea7&scoped=true"
import script from "./AddCategoryModal.vue?vue&type=script&lang=js"
export * from "./AddCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc26ea7",
  null
  
)

export default component.exports